import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {getFilterIcon} from '../../../../utils/listingAttributeIconHelper';
import LabeledOption from '../react-labeled-option';

function SeatFeatures({features, onChange}) {
  const seatFeaturesMap = features.map(({key, label, id, selected, name, type}) => (
    <LabeledOption
      icon={getFilterIcon(id)}
      key={key}
      onClick={(event) => {
        onChange({event, id, selected: !selected, type});
      }}
      selected={selected}
      label={label}
      id={(label && label.props && label.props.id) || name}
    />
  ));

  return (
    <section className="ListingsFilter__sectionContainer">
      <h3 className="ListingsFilter__sectionContainer__Header">
        <FormattedMessage defaultMessage="Features" id="ListingsFilter.seatFeaturesHeader" />
      </h3>
      {seatFeaturesMap}
    </section>
  );
}

SeatFeatures.propTypes = {
  features: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SeatFeatures;
